import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';

const ProjectTimeline = ({item, open, handleClose}) => {

    const dateData = useSelector(state => state.dateData)
    const selectedDate = useSelector(state => state.chooseWeek)
    const dateTotal = useSelector(state => state.chartData)


    const [timelineData, setTimelineData] = useState({})


    useEffect(() => {
        // make a object with all the projects and the dates of the selected week
        const temp = {}
        Object.keys(dateData.value).map((date) => {
            const currentDate = new Date(dateData.value[date].datum)
            currentDate.setHours(0,0,0,0)

            if (currentDate >= selectedDate.value.from && currentDate <= selectedDate.value.to) {
                if (dateData.value[date].tariefomschrijving == item) {
                    temp[date] = dateData.value[date]
                    
                    // search through the dateDat object for the same date and the same item and add the amount to the temp object
                    Object.keys(dateTotal.value).map((date2) => {
                        if (new Date(dateTotal.value[date2].date).getTime() == currentDate.getTime()) {
                            // make a new entry that is called 'voorraad' and set dateTotal.value[date2][item] to it
                            // temp[date].voorraad = dateTotal.value[date2][item]
                            // console.log(dateTotal.value[date2][item])
                            // copy the temp object and add the new entry
                            const temp2 = {...temp[date], voorraad: dateTotal.value[date2][item]}
                            temp[date] = temp2

                        }
                    })

                }
            }  
        })
        // make a list and sort the temp object on date
        const list = Object.keys(temp).map((key) => {
            return temp[key]
        }
        )
        list.sort((a, b) => {
            return new Date(a.datum) - new Date(b.datum)
        }
        )
        // make a new object with the sorted list
        const temp2 = {}
        list.map((item) => {
            temp2[item.datum] = item
        }
        )
        // console.log(temp2)
        setTimelineData(temp2)

    }, [item])

    const dateTimeFormatter = (date) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(date).toLocaleDateString('nl-NL', options)
    }




    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: '0 5px 16px rgba(0, 0, 0, 0.2)',
        p: 4,
        overflowY: 'scroll',
        overflowX: 'hidden',
        maxHeight: '80vh',
    };

  return (
    <div>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <h2>{item}</h2>
                <Timeline>  
                    {Object.keys(timelineData).map((date, index) => {
                        return (
                                <TimelineItem key={index}>
                                    <TimelineOppositeContent color="text.secondary"> { dateTimeFormatter(timelineData[date].datum)  } </TimelineOppositeContent>
                                    <TimelineSeparator>
                                            {timelineData[date].voorraad > 0 && <Tooltip title={`${timelineData[date].voorraad} stuks na project`}><TimelineDot sx={{ bgcolor: 'green' }}/></Tooltip>}
                                            {timelineData[date].voorraad == 0 && <Tooltip title={`${timelineData[date].voorraad} stuks na project`}><TimelineDot sx={{ bgcolor: 'orange' }} /></Tooltip> }
                                            {timelineData[date].voorraad < 0 && <Tooltip title={`${timelineData[date].voorraad} stuks na project`}><TimelineDot sx={{ bgcolor: 'red' }} /></Tooltip> }
                                        {index != Object.keys(timelineData).length - 1 && <TimelineConnector /> }
                                    </TimelineSeparator>
                                    <TimelineContent>{`${timelineData[date].project} (${timelineData[date].aantal} stuks)` }</TimelineContent>
                                </TimelineItem>
                        )
                    })}

                </Timeline>


            </Box>


        </Modal>
    </div>
  )
}

export default ProjectTimeline